module.exports = __webpack_public_path__ + "img/1.9ba0c481.jpg";